import { shouldBeTruthy, shouldBeBoolean, shouldBeNumber } from '@/helpers/validation.js'

export default segment => {
  const valids = []
  valids.push(shouldBeTruthy(segment, 'code', 'segment'))
  valids.push(shouldBeTruthy(segment, 'name', 'segment'))
  valids.push(shouldBeNumber(segment, 'order', 'segment'))
  valids.push(shouldBeTruthy(segment, 'color', 'segment'))
  valids.push(shouldBeBoolean(segment, 'enabled', 'segment'))
  return valids.reduce((a, b) => a && b)
}
